export const ATTRIBUTES = [
  { key: 'Water', label: '물' },
  { key: 'Fire', label: '불' },
  { key: 'Wind', label: '풍' },
  { key: 'Light', label: '빛' },
  { key: 'Dark', label: '암' },
];

export const ATTRIBUTE_KEYS = ATTRIBUTES.map(a => a.key);



export const ATTR_IMG: Record<string, string> = {
  Water: '/images/water.png',
  Fire: '/images/fire.png',
  Wind: '/images/wind.png',
  Light: '/images/light.png',
  Dark: '/images/dark.png',
};

export const STAR_IMG: Record<number, string> = {
  1: '/images/star.png',
  2: '/images/star2.png',
}; 